
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-tips/[itemKey]/[contentKey]",
      function () {
        return require("private-next-pages/study-tips/[itemKey]/[contentKey].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-tips/[itemKey]/[contentKey]"])
      });
    }
  